import { Component } from "@angular/core";
import { WorkerAccount } from "@salaxy/core";
import { SalaxyContext } from "../../../services/index";

/* tslint:disable */
/* TODO: Waiting for rewrite / final implementation */

/** Provides a standard user interface to edit a worker object. */
@Component({
    selector: "salaxy-worker-list",
    template: `<mat-list>
    <h3 md-subheader>Työntekijät</h3>
    <mat-list-item *ngFor="let worker of list" (click)="setCurrentId(worker.id)" class="click">
        <salaxy-avatar style="font-size: 48px;" [avatar]="worker.avatar" md-list-avatar>></salaxy-avatar>
        <h4 md-line>{{ worker.avatar.displayName }}</h4>
        <p md-line>{{ worker.id }}</p>
    </mat-list-item>
</mat-list>
`,
})
export class NgWorkerListComponent {

    constructor(protected context: SalaxyContext) {
    }

    /** The item that is currently in edit / detail view */
    public get current(): WorkerAccount {
        return  this.context.workers.current;
    }

    /**
     * Delete the item from repository.
     * Note that this may not always be possible. At least check model.isReadOnly
     * @param id - Identifier for the item to be deleted.
     */
    public delete(id: string) {
        this.context.workers.delete(id);
    }

    public get list() {
        return this.context.workers.list;
    }

    public setCurrentId(id: string) {
        this.context.workers.setCurrentId(id);
    }

}
